import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'dmmp-basic-content',
  templateUrl: './basic-content.component.html'
})
export class BasicContentComponent implements OnInit {
  @Input() module
  @Input() identifier
  @Input() data
  constructor() { }

  ngOnInit(): void {
  }

}
